/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgTableDataTypeNumberFilled = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8.99 2.877a.75.75 0 0 0-1.48-.254l-.667 3.88-3.093.001a.75.75 0 0 0 0 1.5l2.835-.001-.688 3.995L2.75 12a.75.75 0 1 0 0 1.5l2.889-.001-.624 3.624a.75.75 0 1 0 1.478.254l.668-3.88 4.477-.001-.625 3.627a.75.75 0 1 0 1.479.254l.668-3.882 3.094-.001a.75.75 0 0 0 0-1.5l-2.835.001.688-3.996 3.143-.001a.75.75 0 1 0 0-1.5l-2.885.001.624-3.622a.75.75 0 0 0-1.478-.254L12.843 6.5l-4.478.002.624-3.625Zm-.883 5.125L12.585 8l-.689 3.996-4.477.002.688-3.996Z"
    }));
export default SvgTableDataTypeNumberFilled;
